import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DelhiHotels from './delhi.json';
import './Delhi.css';

const Delhi = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredHotels = DelhiHotels.filter((hotel) =>
    (hotel.name?.toLowerCase() || '').includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container">
      <h2 className="title">Hotels in Delhi</h2>

      <nav className="navbar">
        <input
          type="text"
          placeholder="Search hotels..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <Link to="/city" className="back-link">Back</Link>
      </nav>

      <div className="hotel-grid">
        {filteredHotels.map((hotel, index) => (
          <div className="hotel-card" key={index}>
            <img src={hotel.image} alt={hotel.name} className="hotel-img" />
            <div className="hotel-details">
              <h3>{hotel.name}</h3>
              <p>{hotel.city}</p>
              <p><strong>{hotel.star}</strong></p>
              <p><strong>Rating:</strong> {hotel.rating}</p>
              <p><strong>Price:</strong> {hotel.price}</p>
              <p><strong>Address:</strong> {hotel.address}</p>
              <p><strong>Description:</strong> {hotel.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Delhi;
